<app-header></app-header>
<div class="p-0 booking-page">
  <div class="row g-0 min-vh-100">

    <!-- CONFIRMATION PAGE (Full Width - No Container) -->
    <ng-container *ngIf="step === 3">
      <app-step-confirmation></app-step-confirmation>
    </ng-container>

    <!-- BOOKING STEPS (With Container) -->
    <div class="col-lg-12 col-12 px-5 py-4 padding-none" *ngIf="step !== 3">
      <div class="container">
        <div class="d-flex justify-content-end">
          <button class="btn btn-call" (click)="navigatetoHome()">
            <i class="fa-solid fa-house"></i> &nbsp; Back to home
          </button> &nbsp; &nbsp;
          <button class="btn btn-call">
            <i class="bi bi-telephone"></i> &nbsp; Call to Book
          </button>
        </div>
      </div>

      <!-- TOP BAR (EXACT LIKE SCREENSHOT) -->
      <div class="mb-4 topbar container">
        <div class="progress-section">
          <div class="steps-row">
            <div class="step-item">
              <div class="step-number" [class.active]="step >= 0">1</div>
              <div class="step-title" [class.active]="step >= 0">LOCATION & TIME</div>
            </div>
            <div class="step-item">
              <div class="step-number" [class.active]="step >= 1">2</div>
              <div class="step-title" [class.active]="step >= 1">PASSENGER & VEHICLE</div>
            </div>
            <div class="step-item">
              <div class="step-number" [class.active]="step >= 2">3</div>
              <div class="step-title" [class.active]="step >= 2">BOOKING SUMMARY</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Dynamic Steps -->
      <div class="mt-4">
        <ng-container [ngSwitch]="step">
          <app-step-location *ngSwitchCase="0"></app-step-location>
          <app-step-passenger *ngSwitchCase="1"></app-step-passenger>
          <app-step-summary *ngSwitchCase="2"></app-step-summary>
        </ng-container>
      </div>
    </div>

  </div>
</div>
